module.exports = __webpack_public_path__ + "img/waiting1.09ac3042.svg";